// import React, { useState, useEffect } from "react";
// import axios from "axios";
// import Table from "../Table/Table";
// import { useNavigate } from "react-router-dom";
// import { FaEye, FaEdit } from "react-icons/fa";

// const ViewProject = () => {
//   const [tableData, setTableData] = useState([]);
//   const [tableHeader, setTableHeader] = useState([]);
//   const [currentPage, setCurrentPage] = useState(1);
//   const [order, setOrder] = useState("asc");
//   const [orderBy, setOrderBy] = useState("");
//   const itemsPerPage = 10;
//   const navigate = useNavigate(); // Used to navigate to another page

//   useEffect(() => {
//     setTableHeader([
//       { dbParam: "sr_n", displayName: "Sr. No" },
//       { dbParam: "projectName", displayName: "Project Name" },
//       { dbParam: "spvName", displayName: "SPV Name" },
//       { dbParam: "projectId", displayName: "Project ID" },
//       { dbParam: "startDate", displayName: "Start Date" },
//       { dbParam: "endDate", displayName: "End Date" },
//       { dbParam: "status", displayName: "Status" },
//       { dbParam: "action", displayName: "View / Edit" }, // Single Action column
//     ]);

//     const baseURL = process.env.REACT_APP_API_BASE_URL;
//     console.log("Base URL:", baseURL);

//     // Fetching data from API
//     axios
//       .get(`${baseURL}get_all_project_summary`)
//       .then((response) => {
//         setTableData(
//           response.data.map((project, index) => ({
//             sr_n: index + 1, // Auto-generate Sr. No
//             projectName: project.projectName,
//             spvName: project.spvName,
//             projectId: project.projectId,
//             startDate: project.startDate,
//             endDate: project.endDate,
//             status: project.status,
//           }))
//         );
//       })
//       .catch((error) => {
//         console.error("Error fetching data:", error);
//       });
//   }, []);

//   const handleSort = (property) => {
//     const isAsc = orderBy === property && order === "asc";
//     setOrder(isAsc ? "desc" : "asc");
//     setOrderBy(property);

//     const sortedData = [...tableData].sort((a, b) => {
//       if (a[property] < b[property]) return isAsc ? 1 : -1;
//       if (a[property] > b[property]) return isAsc ? -1 : 1;
//       return 0;
//     });

//     setTableData(sortedData);
//   };

//   const handleEditClick = (row) => {
//     navigate(`/edit-project/${row.projectId}`);
//   };

//   const handleViewClick = (row) => {
//     navigate(`/view-project-details/${row.projectId}`); // Navigate to project details page
//   };

//   const indexOfLastItem = currentPage * itemsPerPage;
//   const indexOfFirstItem = indexOfLastItem - itemsPerPage;
//   const currentData = tableData.slice(indexOfFirstItem, indexOfLastItem);

//   const handlePreviousPage = () => {
//     setCurrentPage((prevPage) => Math.max(prevPage - 1, 1));
//   };

//   const handleNextPage = () => {
//     setCurrentPage((prevPage) =>
//       prevPage * itemsPerPage < tableData.length ? prevPage + 1 : prevPage
//     );
//   };

//   return (
//     <div className="mt-5 space-y-2">
//       <Table
//         tableHeaders={tableHeader}
//         tableData={currentData.map((row) => ({
//           ...row,
//           action: (
//             <div className="flex justify-center space-x-2">
//               <FaEdit
//                 className="text-[#424752] cursor-pointer"
//                 onClick={() => handleEditClick(row)}
//               />
//               <FaEye
//                 className="text-[#424752] cursor-pointer"
//                 onClick={() => handleViewClick(row)}
//               />
//             </div>
//           ),
//         }))}
//         order={order}
//         orderBy={orderBy}
//         handleSort={handleSort}
//       />
//       <div className="flex justify-between items-center">
//         <button
//           onClick={handlePreviousPage}
//           disabled={currentPage === 1}
//           className="px-4 py-2 bg-gray-200 rounded"
//         >
//           Previous
//         </button>
//         <span>
//           Page {currentPage} of {Math.ceil(tableData.length / itemsPerPage)}
//         </span>
//         <button
//           onClick={handleNextPage}
//           disabled={currentPage * itemsPerPage >= tableData.length}
//           className="px-4 py-2 bg-gray-200 rounded"
//         >
//           Next
//         </button>
//       </div>
//     </div>
//   );
// };

// export default ViewProject;

// import React, { useState, useEffect } from "react";
// import axios from "axios";
// import Table from "../Table/Table";
// import { useNavigate } from "react-router-dom";
// import { FaEye, FaEdit, FaTrashAlt } from "react-icons/fa";

// const ViewProject = ({ onEdit }) => {
//   const [tableData, setTableData] = useState([]);
//   const [tableHeader, setTableHeader] = useState([]);
//   const [currentPage, setCurrentPage] = useState(1);
//   const itemsPerPage = 10;
//   const navigate = useNavigate();

//   // Reuse the same role parsing logic as in Navbar
//   const getUserRoles = () => {
//     const stored = sessionStorage.getItem("userRoles");
//     if (!stored) return [];
//     try {
//       const parsed = JSON.parse(stored);
//       return Array.isArray(parsed) ? parsed : [];
//     } catch {
//       return stored.split(",").map(r => r.trim()).filter(Boolean);
//     }
//   };

//   // Extract project name: project_NHPC_300MW_view → NHPC_300MW
//   const extractProjectName = (role) => {
//     const match = role.match(/^project_(.+)_view$/);
//     return match ? match[1] : null;
//   };

//   // Global permissions
//   const userRoles = getUserRoles();
//   const hasEdit = userRoles.includes("Workspace_Edit");
//   const hasDelete = userRoles.includes("Workspace_Delete");
//   const hasGlobalView = userRoles.includes("Workspace_View") || hasEdit;

//   useEffect(() => {
//     setTableHeader([
//       { dbParam: "sr_n", displayName: "Sr. No" },
//       { dbParam: "projectName", displayName: "Project Name" },
//       { dbParam: "spvName", displayName: "SPV Name" },
//       { dbParam: "projectId", displayName: "Project ID" },
//       { dbParam: "startDate", displayName: "Start Date" },
//       { dbParam: "endDate", displayName: "End Date" },
//       { dbParam: "status", displayName: "Status" },
//       { dbParam: "action", displayName: "Action" },
//     ]);

//     const baseURL = process.env.REACT_APP_API_BASE_URL;

//     axios
//       .get(`${baseURL}get_all_project_summary`)
//       .then((response) => {
//         // Get allowed project names using the same logic as Navbar
//         const allowedProjectNames = userRoles
//           .map(extractProjectName)
//           .filter(Boolean);

//         let filteredProjects = response.data;

//         // If user has project-specific view roles → filter strictly
//         if (allowedProjectNames.length > 0) {
//           filteredProjects = response.data.filter((project) =>
//             allowedProjectNames.includes(project.projectName)
//           );
//         }
//         // If no project-specific roles but has global Workspace_View → show all
//         else if (!hasGlobalView) {
//           filteredProjects = []; // No access at all
//         }
//         // Else: hasGlobalView → show all projects

//         const projects = filteredProjects.map((project, index) => ({
//           sr_n: index + 1,
//           projectName: project.projectName,
//           spvName: project.spvName || "-",
//           projectId: project.projectId,
//           startDate: project.startDate || "-",
//           endDate: project.endDate || "-",
//           status: project.status,
//           _raw: project,
//         }));

//         setTableData(projects);
//       })
//       .catch((error) => {
//         console.error("Error fetching projects:", error);
//         setTableData([]);
//       });
//   }, []);

//   const handleEdit = (row) => {
//     onEdit(row.projectId);
//   };

//   const handleView = (row) => {
//     navigate(`/view-project-details/${row.projectId}`);
//   };

//   const handleDelete = (row) => {
//     if (window.confirm(`Are you sure you want to delete project: ${row.projectName}?`)) {
//       alert("Delete API not connected yet — icon works!");
//     }
//   };

//   // Pagination
//   const indexOfLastItem = currentPage * itemsPerPage;
//   const indexOfFirstItem = indexOfLastItem - itemsPerPage;
//   const currentData = tableData.slice(indexOfFirstItem, indexOfLastItem);

//   return (
//     <div className="mt-5 space-y-2">
//       <Table
//         tableHeaders={tableHeader}
//         tableData={currentData.map((row) => ({
//           ...row,
//           action: (
//             <div className="flex justify-center items-center space-x-4">
//               {hasEdit && (
//                 <FaEdit
//                   title="Edit Project"
//                   className="text-[#424752] text-sm cursor-pointer hover:text-green-600 transition-colors"
//                   onClick={() => handleEdit(row)}
//                 />
//               )}

//               {/* Show View icon if user has global view OR specific access to this project */}
//               {(hasGlobalView || userRoles.includes(`project_${row.projectName}_view`)) && (
//                 <FaEye
//                   title="View Details"
//                   className="text-[#424752] text-sm cursor-pointer hover:text-blue-600 transition-colors"
//                   onClick={() => handleView(row)}
//                 />
//               )}

//               {hasDelete && (
//                 <FaTrashAlt
//                   title="Delete Project"
//                   className="text-[#424752] text-sm cursor-pointer hover:text-red-600 transition-colors"
//                   onClick={() => handleDelete(row)}
//                 />
//               )}
//             </div>
//           ),
//         }))}
//       />

//       {/* Pagination */}
//       <div className="flex justify-between items-center mt-6 text-sm">
//         <button
//           onClick={() => setCurrentPage((p) => Math.max(p - 1, 1))}
//           disabled={currentPage === 1}
//           className="px-5 py-2 bg-gray-200 rounded hover:bg-gray-300 disabled:opacity-50 disabled:cursor-not-allowed transition"
//         >
//           Previous
//         </button>

//         <span className="font-medium">
//           Page {currentPage} of {Math.ceil(tableData.length / itemsPerPage) || 1}
//         </span>

//         <button
//           onClick={() =>
//             setCurrentPage((p) => (p * itemsPerPage < tableData.length ? p + 1 : p))
//           }
//           disabled={currentPage * itemsPerPage >= tableData.length}
//           className="px-5 py-2 bg-gray-200 rounded hover:bg-gray-300 disabled:opacity-50 disabled:cursor-not-allowed transition"
//         >
//           Next
//         </button>
//       </div>
//     </div>
//   );
// };

// export default ViewProject;

import React, { useState, useEffect } from "react";
import Table from "../Table/Table";
import { useNavigate } from "react-router-dom";
import { FaEye, FaEdit, FaTrash } from "react-icons/fa";
import apiClient from "../../pages/keycloak/axiosInstance";

const ViewProject = ({ onEdit }) => {
  const [tableData, setTableData] = useState([]);
  const [tableHeader, setTableHeader] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;
  const navigate = useNavigate();

  // Role check
  const userRoles = JSON.parse(sessionStorage.getItem("userRoles") || "[]");
  const canEdit = userRoles.includes("Workspace_Edit");
  const canDelete = userRoles.includes("Workspace_Delete");
  // Modal states
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [showWarningModal, setShowWarningModal] = useState(false);
  const [projectToDelete, setProjectToDelete] = useState(null);
  const [isDeleting, setIsDeleting] = useState(false);

  const loadProjects = () => {
    const allowedProjectNames = JSON.parse(sessionStorage.getItem("allowedProjectNames") || "[]");

    apiClient
      .get(`get_all_project_summary`)
      .then((response) => {
        const allProjects = response.data.map((project) => ({
          projectName: project.projectName,
          spvName: project.spvName || "-",
          projectId: project.projectId,
          startDate: project.startDate || "-",
          endDate: project.endDate || "-",
          status: project.status,
          _raw: project,
        }));

        const filtered = allowedProjectNames.length > 0
          ? allProjects.filter(p => allowedProjectNames.includes(p.projectName))
          : [];

        setTableData(filtered);
      })
      .catch((error) => {
        console.error("Error fetching projects:", error);
        setTableData([]);
      });
  };

  useEffect(() => {
    setTableHeader([
      { dbParam: "sr_n", displayName: "Sr. No" },
      { dbParam: "projectName", displayName: "Project Name" },
      { dbParam: "spvName", displayName: "SPV Name" },
      { dbParam: "projectId", displayName: "Project ID" },
      { dbParam: "startDate", displayName: "Start Date" },
      { dbParam: "endDate", displayName: "End Date" },
      { dbParam: "status", displayName: "Status" },
      { dbParam: "action", displayName: "Action" },
    ]);

    loadProjects();
  }, []);

  const handleEdit = (row) => {
    onEdit(row.projectId);
  };

  const handleView = (row) => {
    navigate(`/view-project-details/${row.projectId}`);
  };

  const openConfirmModal = (row) => {
    setProjectToDelete(row);
    setShowConfirmModal(true);
  };

  const proceedToWarning = () => {
    setShowConfirmModal(false);
    setShowWarningModal(true);
  };

  const cancelDelete = () => {
    setShowConfirmModal(false);
    setShowWarningModal(false);
    setProjectToDelete(null);
  };

  const performDelete = () => {
    if (!projectToDelete || isDeleting) return;

    setIsDeleting(true);

    apiClient
      .post(`delete_project`, { project_id: projectToDelete.projectId })
      .then(() => {
        loadProjects();
        cancelDelete();
        // Optional: add success toast here if you have one
      })
      .catch((error) => {
        console.error("Error deleting project:", error);
        alert("Failed to delete the project. Please try again later.");
      })
      .finally(() => {
        setIsDeleting(false);
      });
  };

  // Pagination logic
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentData = tableData.slice(indexOfFirstItem, indexOfLastItem);

  const displayedData = currentData.map((row, index) => ({
    ...row,
    sr_n: indexOfFirstItem + index + 1,
    action: (
      <div className="flex justify-center items-center space-x-4">
        {canEdit && (
          <FaEdit
            title="Edit Project"
            className="text-[#424752] text-sm cursor-pointer hover:text-green-600 transition-colors"
            onClick={() => handleEdit(row)}
          />
        )}
        <FaEye
          title="View Details"
          className="text-[#424752] text-sm cursor-pointer hover:text-blue-600 transition-colors"
          onClick={() => handleView(row)}
        />
        {canDelete && (
          <FaTrash
            title="Delete Project"
            className="text-[#424752] text-sm cursor-pointer hover:text-red-600 transition-colors"
            onClick={() => openConfirmModal(row)}
          />
        )}
      </div>
    ),
  }));

  const totalPages = Math.ceil(tableData.length / itemsPerPage);

  return (
    <div className="mt-5 space-y-2">
      <Table tableHeaders={tableHeader} tableData={displayedData} />

      {tableData.length > itemsPerPage && (
        <div className="flex justify-between items-center mt-6 text-sm">
          <button
            onClick={() => setCurrentPage(p => Math.max(p - 1, 1))}
            disabled={currentPage === 1}
            className="px-5 py-2 bg-gray-200 rounded hover:bg-gray-300 disabled:opacity-50 disabled:cursor-not-allowed transition"
          >
            Previous
          </button>
          <span className="font-medium">
            Page {currentPage} of {totalPages}
          </span>
          <button
            onClick={() => setCurrentPage(p => (p < totalPages ? p + 1 : p))}
            disabled={currentPage === totalPages}
            className="px-5 py-2 bg-gray-200 rounded hover:bg-gray-300 disabled:opacity-50 disabled:cursor-not-allowed transition"
          >
            Next
          </button>
        </div>
      )}

      {tableData.length === 0 && (
        <p className="text-center text-gray-500 py-8">
          No projects assigned to display
        </p>
      )}

      {/* First Confirmation Modal */}
      {showConfirmModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg shadow-xl p-8 max-w-md w-full mx-4">
            <h2 className="text-2xl font-bold text-gray-800 mb-4">Confirm Deletion</h2>
            <p className="text-gray-700 mb-6">
              Are you sure you want to delete the project{" "}
              <span className="font-semibold">{projectToDelete?.projectName}</span> (ID:{" "}
              <span className="font-semibold">{projectToDelete?.projectId}</span>)?
            </p>
            <div className="flex justify-end space-x-4">
              <button
                onClick={cancelDelete}
                className="px-6 py-3 bg-gray-200 text-gray-800 rounded-lg hover:bg-gray-300 transition"
              >
                Cancel
              </button>
              <button
                onClick={proceedToWarning}
                className="px-6 py-3 bg-red-600 text-white rounded-lg hover:bg-red-700 transition"
              >
                Yes, Proceed
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Second Warning Modal */}
      {showWarningModal && (
        <div className="fixed inset-0 bg-black bg-opacity-60 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg shadow-2xl p-8 max-w-lg w-full mx-4">
            <div className="flex items-center mb-6">
              <div className="text-red-600 text-4xl mr-4">⚠️</div>
              <h2 className="text-2xl font-bold text-gray-800">Permanent Deletion Warning</h2>
            </div>

            <p className="text-lg text-red-600 font-semibold mb-4">
              This action is irreversible!
            </p>

            <p className="text-gray-700 mb-6">
              Deleting the project <span className="font-semibold">{projectToDelete?.projectName}</span> (ID:{" "}
              <span className="font-semibold">{projectToDelete?.projectId}</span>) will permanently remove:
            </p>

            <ul className="list-disc pl-6 text-gray-700 space-y-2 mb-8">
              <li>All uploaded materials, documents, and files</li>
              <li>All manually entered data and forms</li>
              <li>All project details, configurations, and associated records</li>
              <li>Any related history, logs, and metadata</li>
            </ul>

            <p className="text-gray-700 font-medium">
              Once deleted, this project and its data cannot be recovered.
            </p>

            <div className="flex justify-end space-x-4 mt-8">
              <button
                onClick={cancelDelete}
                disabled={isDeleting}
                className="px-6 py-3 bg-gray-200 text-gray-800 rounded-lg hover:bg-gray-300 transition disabled:opacity-50"
              >
                Cancel
              </button>
              <button
                onClick={performDelete}
                disabled={isDeleting}
                className="px-6 py-3 bg-red-700 text-white rounded-lg hover:bg-red-800 transition disabled:opacity-50 flex items-center"
              >
                {isDeleting ? "Deleting..." : "Delete Permanently"}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ViewProject;